/* eslint-disable  */
import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { SuccessMessage, ErrorMessage } from "../../../../utils/toastify";
import { useAuth } from "../../../../Context/AuthContext";
import { useEncrypt } from "../../hooks/useEncrypt";
import { ApiRCSEndpoint } from "../../../../utils/ApiEndpoint";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import _ModalSendTestRCS from "./_ModalSendTestRCS";
import _Button from "../../../generic/_Button";
import { useFormikContext } from "formik";
import TestRCS from "../../../../utils/classes/test-message-rcs";
const phoneSchema = Yup.string()
  .required("Por favor, ingrese un número de teléfono")
  .matches(/^[0-9]+$/, "Solo se permiten números")
  .length(10, "El número debe tener 10 dígitos");

const SendTestRCS = (props) => {
  const auth = useAuth();
  const user = auth.getSessionData();
  const { values, errors } = useFormikContext();
  const { messageWithTemplate = "" } = props;
  const { getEncrypt } = useEncrypt();
  const [visible, setVisible] = useState({
    visible: false,
    data: false,
  });

  const [phone, setPhone] = useState(user?.vc_phone || "");
  const { mutate: sendRCS, isPending: isSending } = useMutation({
    mutationFn: async () => {
      const currentTime = Date.now();
      const data = {
        security: {
          partner_id: user.vc_partnerid,
          time: currentTime,
          hash: getEncrypt(user.vc_partnerid, currentTime, user.vc_secretkey),
        },
              xtraparams: {
            panelUserId: user.uid_user,
            source: "Panel RCS",
          },
        notify: {
          service_id: user.vc_serviceid,
          number: phone,
          message: "",
          channel: "RCS",
          rcsMessage: {

          }
        },
      };

      const Resolver = new TestRCS({...values, fallback: "Tu dispositivo no soporta mensajes RCS"});

      const { rcsMessage, message } = Resolver.buildTestData();

      data.notify.message = message;
      data.notify.rcsMessage = rcsMessage;
   const response = await axios({
     method: "post",
     headers: {
       "Content-Type": "application/json",
     },
     url: ApiRCSEndpoint,
     data: data,
   });

   return response.data;

    },
    onSuccess: (data) => {
      if (data.result.code !== "0") {
        ErrorMessage("Error al enviar el RCS de prueba");
      }

      setVisible({ visible: false, data: false });
      SuccessMessage("RCS de prueba enviado con éxito");
    },
    onError: () => {
      ErrorMessage("Error al enviar el RCS de prueba");
    },
  });

  if (!user.vc_phone || ![2, 3].includes(user?.id_usertype)) return null;

  const { isError, errorMsg } = useMemo(() => {
    try {
      phoneSchema.validateSync(phone);
      return { isError: false, errorMsg: "" };
    } catch (err) {
      return { isError: true, errorMsg: err.message };
    }
  }, [phone]);

  const validatePhone = () => {
    try {
      phoneSchema.validateSync(phone);
      return true;
    } catch (err) {
      return false;
    }
  };

const isValidateSendTest = useMemo(() => {
  if (values.step === 1) {
    return messageWithTemplate
  }


  if (values.step === 2) {
    const keysStep2 = ['title_rcs_message', 'imageUrl', 'cardOrientation', 'height', 'rcsmessage'];

    return !keysStep2.some((key) => errors[key]);
  }

  if (values.step === 3) {
    return !errors.cards;
  }

  return false;
}, [values.step, messageWithTemplate, errors]);

  return (
  <>
  <div className="Divider" />
    <div className="w-full my-2 flex justify-center">
      <_Button
        style="secondary"
        disabled={!isValidateSendTest || isSending}
        onClick={() => setVisible({ visible: true, data: messageWithTemplate })}
        title="Enviar RCS de prueba"
        className="w-full"
      />
      <_ModalSendTestRCS
        visible={visible.visible}
        onClose={() => setVisible({ visible: false, data: false })}
        title="Enviar SMS de prueba"
        onAction={() => {
          if (!validatePhone()) {
            ErrorMessage("Por favor, ingrese un número de teléfono");
            return;
          }
          sendRCS();
        }}
        defaultData={phone}
        onHandlePhone={(e) => setPhone(e.target.value)}
        isLoading={isSending}
        isError={isError}
        errorMsg={errorMsg}
      />
    </div></>
  );
};

SendTestRCS.propTypes = {
  messageWithTemplate: PropTypes.string,
};

export default SendTestRCS;
